import {orderBy, pick} from 'lodash'
import moment from 'moment'
import React from 'react'
import Select from 'react-select'
import Modal from 'react-modal'
import DatePicker from "react-datepicker"
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import Text from 'react-text'
import * as dateLocale from 'date-fns/locale'
import {Context} from '../../context'
import {viewerGuard} from 'helpers/url'
import "react-datepicker/dist/react-datepicker.css"
import 'react-confirm-alert/src/react-confirm-alert.css'
import './index.styl'

class DateInput extends React.Component {
  render () {
    return (
      <div className="date-input" onClick={this.props.onClick}>
        <FontAwesomeIcon icon={faCalendarAlt} />
        {this.props.value}
      </div>
    )
  }
}

function Buttons ({left, right}) {
  return (
    <div className="buttons">
      <button disabled={!left.enabled} className={left.label} onClick={left.onClick}>
        <Text id={`${left.label}_label`} />
      </button>
      <button disabled={!right.enabled} className={right.label} onClick={right.onClick}>
        <Text id={`${right.label}_label`} />
      </button>
    </div>
  )
}

export default class PrintPDF extends React.Component {

  static contextType = Context

  constructor (props) {
    super(props)
    const setState = this.setState.bind(this)
    this.state = {
      start: props.start,
      end: props.end,
      group: props.group,
      isOpen: true,
      setState
    }
  }

  render () {

    const context = this.context
    const format = date => moment(date).format('YYYY-MM-DD')
    const {setState, isOpen, start, end, group} = this.state

    const locale= context.languageId == 'en' ? dateLocale.enUS : dateLocale.es

    const query = {start: format(start), end: format(end), group: group ? group.id : undefined}
    const href = `//${location.host}/#${context.link({},'/:languageId/:role/planning-pdf', {query})}`
    const navigateOut = () => context.navigate({}, context.match.path.replace(/\/:action.*$/,''), {preserveQuery: true})
    const close = () => setState({isOpen: false})

    return (
      <Modal
        isOpen={isOpen}
        onAfterClose={navigateOut}
        onRequestClose={close}
        contentLabel=""
        className="print-pdf-wrapper"
        appElement={document.querySelector('#root')}
        closeTimeoutMS={800}
        >
          <div className="print-pdf">
            <div className="title">
              <div className="label">
                <Text id="print-plan" />
              </div>
            </div>
            <div className="content">
              <div className="group">
                <label><Text id="group_label" /></label>
                <Select
                  className="select-group"
                  classNamePrefix="select-group"
                  formatOptionLabel = {({name}) => name}
                  isSearchable = {false}
                  isClearable = {true}
                  escapeClearsValue = {true}
                  getOptionValue = {({id}) => id}
                  placeholder = {context.translate("all-groups")}
                  value = {group}
                  onChange = {group => setState({group})}
                  options = {context.groups}
                />
              </div>
              <div className="date">
                <label><Text id="date_label" /></label>
                <div className="inputs">
                  <div className="from">
                    <DatePicker
                    customInput={<DateInput />}
                    locale={locale}
                    selected={moment(start).toDate()}
                    onChange={start => {
                      const end = moment(end).isAfter(start) ? end : moment(start).toDate()
                      setState({start, end})
                    }}
                    />
                  </div>
                  <div className="separator"><div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>-</div></div>
                  <div className="to">
                    <DatePicker
                    customInput={<DateInput />}
                    locale={locale}
                    selected={moment(end).toDate()}
                    onChange={end => setState({end})}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="buttons">
              <button className="button cancel" onClick={close}>
                {context.translate('cancel_label')}
              </button>
              <a className="button continue" onClick={close} {...viewerGuard({href, target: "_blank"})}>
                {context.translate('continue_label')}
              </a>
            </div>
          </div>
        </Modal>
    )
  }
}
